import React from 'react'
import { Stack, Box, Skeleton } from '@mui/material'

const TopLanguagesWidgetSkeleton = () => {
  return (
    <Box
      sx={{
        width: { xs: '100%', sm: '50%', md: '45%' },
        border: '1px solid #EFEFEF',
        borderRadius: '16px',
        padding: 2,
        backgroundColor: '#FFFFFF',
        minHeight: '120px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      }}
    >
      <Stack spacing={0.5} alignItems="center" sx={{ width: '100%' }}>
        <Skeleton variant="circular" width={16} height={16} />
        <Skeleton variant="text" width={140} height={14} />
        <Stack direction="row" spacing={2} sx={{ mt: 1 }}>
          <Stack alignItems="left" spacing={0.5}>
            <Skeleton variant="text" width={60} height={32} />
          </Stack>
          <Stack alignItems="left" spacing={0.5}>
            <Skeleton variant="text" width={60} height={32} />
          </Stack>
        </Stack>
      </Stack>
    </Box>
  )
}

export default TopLanguagesWidgetSkeleton